import React, {
  FunctionComponent, useCallback, useEffect, useRef, useState,
} from 'react';
import { Box, Flex } from 'rebass/styled-components';
import api from '../../api';
import { Loading } from '../../components';
import { useAppState, useNotification } from '../../hooks';

const NormalizePriorities: FunctionComponent<{}> = () => {
  const { isCcsV2, isLoading: isLoadingAppState, accountId } = useAppState();
  const [isLoading, setLoading] = useState<boolean>(false);
  const isMounted = useRef<boolean>(false);
  const [resp, setResp] = useState<Array<any>>([]);
  const { addNotification } = useNotification();

  const normalize = useCallback(async () => {
    if (isMounted.current) {
      setLoading(true);
    }

    try {
      await api.ccsV2.normalizePriorities(accountId);
      const res = await api.ccsV2.getPolicies(accountId);
      if (isMounted.current) {
        setLoading(false);
        setResp(res.docs);
      }
    } catch (err) {
      if (isMounted.current) {
        setLoading(false);
      }
      addNotification(err, 'error');
    }
  }, [accountId, addNotification]);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (accountId && isCcsV2) {
      normalize();
    }
  }, [accountId, isCcsV2, normalize]);

  return isLoading || isLoadingAppState ? (
    <Flex alignItems="center" justifyContent="center" mb={3} mt={4} height="100%">
      <Loading size={24} />
    </Flex>
  ) : (
    <Box sx={{ color: 'white', whiteSpace: 'pre' }}>{resp ? JSON.stringify(resp, null, 2) : ''}</Box>
  );
};

export default NormalizePriorities;
